module.exports = __webpack_public_path__ + "img/Other002373-img2a.cda91058.jpg";